var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M17.787 32.137l4.504 2.349-2.956 3.225a.895.895 0 01-1.542-.486l-.006-.102v-4.986zm20.986-21.05a1.751 1.751 0 011.177 2.08l-.038.132L32.534 35.6a1.79 1.79 0 01-2.406 1.062l-.125-.06-11.818-6.256 14.039-12.938a.164.164 0 00.019-.222.157.157 0 00-.215-.031l-16.58 11.742-6.51-3.446a1.766 1.766 0 01-.748-.758l-.064-.14a1.745 1.745 0 01.869-2.224l.127-.055 28.442-11.151a1.801 1.801 0 011.209-.037z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
